// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Camera from "@insite/mobius/Icons/Camera";
// import Facebook from "@insite/mobius/Icons/Facebook"; // Starter Custom Code
import FileText from "@insite/mobius/Icons/FileText";
// import Instagram from "@insite/mobius/Icons/Instagram"; // Starter Custom Code
// import Linkedin from "@insite/mobius/Icons/Linkedin"; // Starter Custom Code
import Rss from "@insite/mobius/Icons/Rss";
// import Twitter from "@insite/mobius/Icons/Twitter"; // Starter Custom Code
import User from "@insite/mobius/Icons/User";
import Video from "@insite/mobius/Icons/Video";
// import XTwitter from "@insite/mobius/Icons/XTwitter"; // Starter Custom Code
// import Youtube from "@insite/mobius/Icons/Youtube"; // Starter Custom Code
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as cssLinter from "css";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Facebook from "@store/Library/Components/Toolkit/Icons/Brand/Facebook";
import Instagram from "@store/Library/Components/Toolkit/Icons/Brand/Instagram";
import Linkedin from "@store/Library/Components/Toolkit/Icons/Brand/Linkedin";
import Pinterest from "@store/Library/Components/Toolkit/Icons/Brand/Pinterest";
import Twitter from "@store/Library/Components/Toolkit/Icons/Brand/Twitter";
import XTwitter from "@store/Library/Components/Toolkit/Icons/Brand/Twitter";
import Youtube from "@store/Library/Components/Toolkit/Icons/Brand/Youtube";
import Email from "@store/Library/Components/Toolkit/Icons/Email/EmailLine";
import { widgetWrapperStyles } from "@store/Library/Components/Toolkit/WidgetWrapper";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { ExtendedCssProps } from "@toolkit/Framework/Types/StyledTheme";
import { focusStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

const enum fields {
    direction = "direction",
    alignment = "alignment",
    title = "title",
    titleLink = "titleLink",
    links = "links",
    visibilityState = "visibilityState",
    iconSize = "iconSize",
    // Starter Removed - iconColor
    // Starter Removed - backgroundColor
    // Starter Removed - linksPerRow
    customCSS = "customCSS",
    // Starter Custom Code
    label = "label",
    iconSpacing = "iconSpacing",
}

const enum icons {
    instagram = "Instagram",
    facebook = "Facebook",
    youtube = "Youtube",
    twitter = "Twitter",
    xTwitter = "X",
    rss = "Rss",
    user = "User",
    linkedin = "Linkedin",
    camera = "Camera",
    video = "Video",
    notebook = "Notebook",
    // Starter Custom Code
    pinterest = "Pinterest",
    email = "Email",
}

const enum visibilityState {
    both = "both",
    label = "label",
    icon = "icon",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "right";
        [fields.visibilityState]: visibilityState;
        [fields.title]: string;
        [fields.iconSize]: number;
        // Starter Removed - linksPerRow
        // Starter Removed - iconColor
        // Starter Removed - backgroundColor
        [fields.titleLink]: LinkFieldValue;
        [fields.links]: LinkModel[];
        [fields.customCSS]: string;
        // Starter Custom Code
        [fields.label]: string;
        [fields.iconSpacing]: string;
    };
}

interface LinkModel {
    fields: {
        title: string;
        icon: string;
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        overriddenTitle: string;
    };
}

export interface LinkListStyles {
    socialLinkListWrapper?: InjectableCss;
    linkWrapper?: InjectableCss;
    link?: LinkPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    label?: TypographyPresentationProps;
}

export const linkListStyles: LinkListStyles = {
    socialLinkListWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
        `,
    },
    linkWrapper: {
        css: css`
            display: flex;
        `,
    },
    link: {
        typographyProps: {
            color: "inherit",
        },
        icon: {
            iconProps: {
                color: "inherit",
            },
        },
        css: css`
            ${focusStyles()}
            color: inherit;
            transition: ${transitionHoverStyles("color", "transform")};

            &:hover,
            &:active {
                ${(x: ExtendedCssProps) => (x.isIconOnly ? "transform: scale(1.25);" : null)}
                text-decoration: underline;
            }
        `,
    },
    wrapper: {
        css: css`
            ${widgetWrapperStyles.css}
            display: flex;
            /* Store Custom Code - Start */
            align-items: start;
            justify-content: left;
            flex-wrap: wrap;
            flex-direction: column;
            gap: ${pxToRem(12)};
            /* Store Custom Code - End */

            ${breakpoint("md")} {
                justify-content: left;
                /* Store Custom Code - Start */
                align-items: center;
                flex-direction: row;
                gap: 0;
                /* Store Custom Code - End */
            }
        `,
    },
    label: {
        forwardAs: "p",
        /* Store Custom Code - Start */
        css: css`
            letter-spacing: 0.65px;
            font-size: ${pxToRem(13)};
        `,
        /* Store Custom Code - End */
    },
};

export const socialLinksStyles = linkListStyles;

const GetIcon = (icon: string) => {
    switch (icon) {
        case icons.youtube:
            return Youtube;
        case icons.twitter:
            return Twitter;
        case icons.xTwitter:
            return XTwitter;
        case icons.facebook:
            return Facebook;
        case icons.instagram:
            return Instagram;
        case icons.linkedin:
            return Linkedin;
        case icons.notebook:
            return FileText;
        case icons.rss:
            return Rss;
        case icons.user:
            return User;
        case icons.video:
            return Video;
        case icons.camera:
            return Camera;
        /* Starter Custom Code - Start */
        case icons.pinterest:
            return Pinterest;
        case icons.email:
            return Email;
        /* Starter Custom Code - End */
        default:
            break;
    }

    return "";
};

export const SocialLinks: FC<OwnProps> = ({ fields }) => {
    const { links, hasMissingCategories } = useGetLinks(fields.links, o => o.fields.destination);

    const styles = useMergeStyles("socialLinks", linkListStyles);

    if (hasMissingCategories) {
        return null;
    }
    const customCssWrapper = {
        css: css`
            ${styles.wrapper?.css /* Starter Custom Code */}
            ${fields.customCSS}
        `,
    };
    const socialLinkListStyle = css`
        ${fields.direction === "horizontal" ? "flex-direction: row;" : "flex-direction: column;"}
        /* Starter Removed - backgroundColor */
        margin: -${pxToRem(fields.iconSpacing)}; /* Starter Custom Code */
        ${styles.socialLinkListWrapper?.css}
    `;

    const linkWrapperStyle = css`
        /* Starter Removed - flex-basis */
        /* Starter Removed - flex-grow */
        margin: ${pxToRem(fields.iconSpacing)}; /* Starter Custom Code */
        ${styles.linkWrapper?.css}
    `;

    /* Starter Custom Code - Start */
    const iconStyle = css`
        ${() => {
            if (fields.visibilityState === visibilityState.both) {
                return `margin-${fields.alignment === "right" ? "left" : "right"}: ${pxToRem(4)};`;
            }

            return "margin: 0;";
        }}
        ${styles.link?.icon?.iconProps?.css}
    `;

    const labelStyle = css`
        margin-right: ${`calc(${pxToRem(fields.iconSpacing)} * 2)` /* Store Custom Code */};
        ${styles.label?.css}
    `;
    /* Starter Custom Code - End */

    const showIcon = fields.visibilityState === visibilityState.both || fields.visibilityState === visibilityState.icon;
    const showLabel =
        fields.visibilityState === visibilityState.both || fields.visibilityState === visibilityState.label;

    return (
        <StyledWrapper {...customCssWrapper}>
            {/* Starter Custom Code - Start */}
            {fields.label ? (
                <Typography className="social-label" css={labelStyle}>
                    {fields.label}
                </Typography>
            ) : null}
            {/* Starter Custom Code - End */}
            <StyledWrapper className="social-links" css={socialLinkListStyle}>
                {links.map((link, index) => (
                    <StyledWrapper className="link-wrapper" css={linkWrapperStyle} key={index}>
                        {link.url && (
                            <Link
                                className="social-link"
                                {...styles.link}
                                href={link.url}
                                target={
                                    fields.links[index].fields.openInNewWindow
                                        ? "_blank"
                                        : "_self" /* Starter Custom Code */
                                }
                                icon={{
                                    ...styles.link?.icon, // Starter Custom Code
                                    iconProps: {
                                        ...styles.link?.icon?.iconProps, // Starter Custom Code
                                        size: fields.iconSize,
                                        // Starter Removed - iconColor
                                        css: iconStyle, // Starter Custom Code
                                        src: showIcon ? GetIcon(fields.links[index].fields.icon) : undefined,
                                        title: fields.links[index].fields.title,
                                    },
                                    position: fields.alignment,
                                }}
                                // Starter Custom Code
                                isIconOnly={!showLabel}
                                aria-label={!showLabel && fields.links[index].fields.title}
                            >
                                {showLabel && fields.links[index].fields.title}
                            </Link>
                        )}
                    </StyledWrapper>
                ))}
            </StyledWrapper>
        </StyledWrapper> // Starter Custom Code
    );
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.social-links{
}

.link-wrapper{
}

.social-link{
}

.social-label{
}`;
/* Starter Custom Code - End */

const contentTab = {
    displayName: "Content",
    sortOrder: 1,
};
const settingsTab = {
    displayName: "Settings",
    sortOrder: 2,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 3,
};

const definition: WidgetDefinition = {
    group: "Basic",
    icon: "thumbs-up",
    isSystem: true,
    fieldDefinitions: [
        /* Starter Custom Code - Start */
        {
            name: fields.label,
            editorTemplate: "TextField",
            tab: contentTab,
            defaultValue: "Follow us:",
            fieldType: "Translatable",
        },
        {
            name: fields.iconSpacing,
            editorTemplate: "IntegerField",
            tab: contentTab,
            defaultValue: 4,
            fieldType: "General",
            isRequired: true,
        },
        /* Starter Custom Code - End */
        {
            name: fields.links,
            editorTemplate: "ListField",
            tab: contentTab,
            getDisplay: (item: HasFields) => {
                return item.fields.title;
            },
            defaultValue: [],
            fieldType: "Translatable",
            fieldDefinitions: [
                {
                    name: "title",
                    editorTemplate: "TextField",
                    defaultValue: "",
                },
                {
                    name: "icon",
                    displayName: "Select Icon",
                    editorTemplate: "DropDownField",
                    options: [
                        { displayName: "Instagram", value: icons.instagram },
                        { displayName: "Youtube", value: icons.youtube },
                        { displayName: "Facebook", value: icons.facebook },
                        { displayName: "X (Twitter)" /* Starter Custom Code */, value: icons.twitter },
                        // Starter Removed - xTwitter
                        { displayName: "Rss", value: icons.rss },
                        { displayName: "User", value: icons.user },
                        { displayName: "Linkedin", value: icons.linkedin },
                        { displayName: "Camera", value: icons.camera },
                        { displayName: "Video", value: icons.video },
                        { displayName: "Notebook", value: icons.notebook },
                        // Starter Custom Code
                        { displayName: "Pinterest", value: icons.pinterest },
                        { displayName: "Email", value: icons.email },
                    ],
                    defaultValue: "",
                },
                {
                    name: "destination",
                    editorTemplate: "LinkField",
                    defaultValue: {
                        value: "",
                        type: "Url",
                    },
                    isRequired: true,
                },
                {
                    name: "openInNewWindow",
                    editorTemplate: "CheckboxField",
                    defaultValue: true, // Starter Custom Code
                },
            ],
        },
        {
            name: fields.direction,
            displayName: "Display",
            editorTemplate: "RadioButtonsField",
            defaultValue: "horizontal",
            horizontal: true,
            fieldType: "General",
            tab: settingsTab,
            sortOrder: 1,
            options: [
                {
                    displayName: "Column",
                    value: "vertical",
                },
                {
                    displayName: "Row",
                    value: "horizontal",
                },
            ],
        },
        {
            name: fields.alignment,
            displayName: "Text Position",
            editorTemplate: "RadioButtonsField",
            defaultValue: "left",
            horizontal: true,
            fieldType: "General",
            tab: settingsTab,
            sortOrder: 2,
            options: [
                {
                    displayName: "Right of icon", // Starter Custom Code
                    value: "left",
                },
                {
                    displayName: "Left of icon", // Starter Custom Code
                    value: "right",
                },
            ],
        },
        {
            name: fields.visibilityState,
            displayName: "Visibility",
            editorTemplate: "RadioButtonsField",
            tab: settingsTab,
            options: [
                {
                    displayName: "Show Both",
                    value: visibilityState.both,
                },
                {
                    displayName: "Show Label Only",
                    value: visibilityState.label,
                },
                {
                    displayName: "Show Icon Only",
                    value: visibilityState.icon,
                },
            ],
            defaultValue: visibilityState.icon, // Starter Custom Code
            fieldType: "General",
            sortOrder: 4,
        },
        {
            name: fields.iconSize,
            displayName: "Icon Size",
            editorTemplate: "IntegerField",
            defaultValue: 30, // Store Custom Code
            min: 1,
            fieldType: "General",
            sortOrder: 3,
            tab: settingsTab,
        },
        /* Starter Removed - fields.linksPerRow */
        /* Starter Removed - fields.iconColor */
        /* Starter Removed - fields.backgroundColor */
        {
            name: fields.customCSS,
            displayName: "Custom CSS",
            editorTemplate: "CodeField",
            fieldType: "General",
            tab: advancedTab,
            defaultValue: defaultCustomCss,
            isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
            validate: value => {
                if (value === undefined || value === null) {
                    return "";
                }

                const result = cssLinter.parse(value, { silent: true });
                if (result?.stylesheet?.parsingErrors) {
                    // the error output at this time only has room for one line so we just show the first error
                    return result.stylesheet.parsingErrors.length <= 0
                        ? ""
                        : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                }

                return "Unable to parse Css";
            },
            options: {
                mode: "css",
                lint: true,
                autoRefresh: true,
            },
        },
    ],
};

const widgetModule: WidgetModule = {
    component: SocialLinks,
    definition,
};

export default widgetModule;
